import EthWallet from "./EthWallet";

export default function SolNft(props: {nft: any}) {
    let nft = props.nft;
    return (
        <tr>
            <td><img alt='' height='50px' src={nft.previews.image_small_url}/></td>
            {/*<td>{chopIt(nft.description, 20)} {nft.name}</td>*/}
            <td>{nft.token_id}</td>
            <td>{nft.last_sale.timestamp.slice(0,10)}</td>
            <td>{nft.last_sale.unit_price / 1000000000}&nbsp;SOL</td>
            <td><EthWallet isSeller={true} currency='SOL' addr={nft.last_sale.from_address} /></td>
            <td><EthWallet isSeller={false} currency='SOL' addr={nft.last_sale.to_address} /></td>
        </tr>
    );
}